import permissions from '../permissions'

const MONITORING_MANAGEMENT_PDCA_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.MONITORING_MANAGEMENT_PDCA.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.MONITORING_MANAGEMENT_PDCA.MANAGE,
  },
]

export default MONITORING_MANAGEMENT_PDCA_LIST
